subscription PurchaseOrderStatementReportStatus($id: UUID!) {
  purchaseOrderStatementReportStatus(id: $id) {
    document {
      id
    }
    status
  }
}
